PJQ.charts = {
    colors: {
        RED_80: 'rgba(255, 99, 132, 0.8)',
        BLUE_80: 'rgba(54, 162, 235, 0.8)',
        YELLOW_80: 'rgba(255, 206, 86, 0.8)',
        GREEN_80: 'rgba(75, 192, 192, 0.8)'
    }
};

PJQ.charts.Chart = class {
    constructor($el, options = {}) {
        this.$outer = $el;
        this.$outer.addClass('chart-outer');
        this.options = _.defaults(options, {
            width: null,
            height: null,
            showTotal: false,
            onClick: _.noop
        });
        this.renderChart();
    }

    renderChart() {
        if (_.size(this.$el) > 0) {
            this.$el.remove();
        }
        if (this.options.width && this.options.height) {
            this.options.options = _.defaults({
                maintainAspectRatio: false
            }, this.options.options ? this.options.options : {});
        }
        this.$el = $('<canvas>', {
            height: this.options.height,
            width: this.options.width,
            style: 'z-index:100 !important;',
        });
        this.$outer.append(this.$el);

        if (this.options.type.toLowerCase() === 'doughnut' && this.options.showTotal) {
            let total = this.options.total;
            if (isNaN(total)) {
                total = _.reduce(this.options.data.datasets[0].data, function (memo, num) {
                    return num + memo;
                }, 0)
            }
            this.$outer.append($('<span />', {
                class: 'chart-total text-align-center fs-40 wd-50 font-weight-light p-absolute left-25',
                style: 'z-index:1 !important;top:' + (this.options.height / 3).toString() + 'px;',
                text: total
            }));
        }

        this.chart = new Chart(this.$el, this.options);

        if (this.options.onClick != null) {
            this.$el.on('click', _.bind(function (e) {
                this.options.onClick(this.chart.getElementsAtEvent(e));
            }, this));
        }
    }
};

PJQ.views.charts = {};
PJQ.views.charts.dhtmlxGantt = PJQ.views.BaseView.extend({
    defaults: {
        enableSorting: false,
        sortField: "sortOrder",
        sortAsc: false,
        onSort: null,
        isShowCriticalPath: false
    },
    events: {
        'click .grid-toggle': 'toggleGrid'
    },
    beforeFirstRender: function () {
        this.collection = this.options.schedule.tasks;
        // Order by id by default
        this.currentSort = {
            field: this.options.sortField != null ? this.options.sortField : 'sortOrder',
            asc: this.options.sortAsc != null ? this.options.sortAsc : false
        };
    },
    afterRender: function () {
        this.initChart();
        this.renderContextMenu();
    },
    getDataObject: function () {
        let result = {
                tasks: [],
                links: [],
                minStartDate: null,
                maxStartDate: null,
                maxEndDate: null,
                hasTaskNearToday: false
            },
            rangeStart = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
            rangeEnd = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), 7);
        _.each(this.collection.models, function (task) {
            let start = null;
            if (task.get('start') != null) {
                start = new Date(task.get('start'));
                if (result.minStartDate == null || start < result.minStartDate) {
                    result.minStartDate = start;
                }
                if (result.maxStartDate == null || start > result.maxStartDate) {
                    result.maxStartDate = start;
                }
            }

            let end = null;
            if (task.get('finish') != null) {
                end = new Date(task.get('finish'));
                if (result.maxEndDate == null || end > result.maxEndDate) {
                    result.maxEndDate = end;
                }
            }

            result.hasTaskNearToday = result.hasTaskNearToday
                || (start != null && end != null && PJQ.helpers.dateHelpers.checkDateRangesOverlap(rangeStart, rangeEnd, start, end))
                || (start != null && PJQ.helpers.dateHelpers.checkDateBetweenDays(rangeStart, rangeEnd, start))
                || (end != null && PJQ.helpers.dateHelpers.checkDateBetweenDays(rangeStart, rangeEnd, end));

            if (task instanceof PJQ.models.schedule.Task) {
                let color = task.get('isMilestone') ? '#43A047' : task.status ? task.status.get('color') : '#0b7bc1'
                let taskObj = {
                    text: task.get('name'),
                    start_date: task.get('start') ? task.get('start') : result.maxStartDate,
                    duration: task.get('isMilestone') ? 1 : task.get('duration'),
                    id: task.get('taskId'),
                    type: task.get('isMilestone') ? 'milestone' : (task.get('isSummaryTask') ? 'project' : 'task'),
                    progress: (task.get('percentComplete') / 100),
                    parent: task.get('summaryTaskId') && task.get('summaryTaskId') !== task.get('taskId') ? task.get('summaryTaskId') : task.get('parentTaskId'),
                    calendar_id: task.get('weekendWork') ? "weekend_work" : null,
                    details: task.get('notes'),
                    bar_height: task.get('isSummaryTask') ? 18 : null,
                    unscheduled: task.get('start') == null && !task.get('isSummaryTask'),
                    color: color,
                    textColor: PJQ.helpers.colorHelpers.idealLinkColorForBackground(color),
                    listTextColor: color,
                    sortOrder: task.get('sortOrder')
                }
                result.tasks.push(taskObj);
            }
        }, this);

        _.each(this.options.schedule.dependencies.models, function (dependency) {
            if (!dependency.get('isDeleted')) {
                let linkObj = {
                    id: dependency.get('dependencyId'),
                    target: dependency.get('taskId'),
                    source: dependency.get('dependTaskId'),
                    type: Object.keys(PJQ.constants.schedule.linkTypes).find(key => PJQ.constants.schedule.linkTypes[key] === dependency.get('type')),
                    lag: dependency.get('offset')
                }

                result.links.push(linkObj);
            }
        }, this);

        return result;
    },
    startInlineEdit: function (taskId, column = 'text') {
        if (!(taskId > 0)) {
            return;
        }

        this.gantt.ext.inlineEditors.startEdit(taskId, column ?? 'text');
    },
    initChart: function () {
        if (this.gantt) {
            this.gantt.destructor();
        }

        let gantt = Gantt.getGanttInstance();
        this.gantt = gantt;

        // Clear all tasks to prevent persistence between projects
        gantt.clearAll();

        gantt.templates.scale_cell_class = (date) => {


            if (date.getDay() === 0 || date.getDay() === 6) {
                return "weekend-highlight";
            }
        };
        gantt.templates.timeline_cell_class = (task, date) => {
            // let taskModel = this.collection.get(task.id);
            // if (taskModel != null && taskModel.get('weekendWork')) {
            //     return;
            // }

            if (date.getDay() === 0 || date.getDay() === 6) {
                return "weekend-highlight";
            }
        };

        // Expand chart date range when task is changed
        gantt.config.fit_tasks = true;

        // Make skin broadway. Default is set to terrace
        gantt.skin = "broadway";

        // Make Gantt change tasks that fall on weekend
        gantt.config.work_time = true;
        gantt.config.correct_work_time = true;

        // Add calendar to Make Gantt respect weekendWork
        gantt.addCalendar({
            id: "weekend_work",
            worktime: {
                days: [1, 1, 1, 1, 1, 1, 1]
            }
        });

        // Define custom editors
        // Date Editor
        let self = this;
        gantt.config.editor_types.dateEditor = {
            show: function (id, column, config, placeholder) {
                placeholder.innerHTML = '<div class="input-group"><input type="text" class="form-control input-date date-editor-input fs-13"></div>';
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);
                self.showDate(taskModel.get('start'));

                this.datePicker = new PJQ.inputs.Datepicker({
                    el: self.$('.date-editor-input'),
                    canEdit: true,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.ALT_DATE,
                        defaultDate: taskModel.get('start') ? taskModel.get('start') : new Date(),
                        minDate: column.name === 'end_date' ? taskModel.get('start') : taskModel.getMinStart(),
                        widgetPositioning: {
                            horizontal: column.name === 'start_date' ? 'left' : 'right'
                        }
                    },
                    onChange: function (value) {
                        if (column.name === 'start_date') {
                            self.gantt.ext.inlineEditors.startEdit(taskModel.get('taskId'), 'end_date');
                        }
                    }
                });
            },
            hide: function (a) {
                this.datePicker.remove();
            },
            set_value: function (value, id, column, node) {
                let taskModel = self.collection.get(value.id);
                let date = new Date(taskModel && taskModel.get('start') ? taskModel.get('start') : value.start_date);
                if (column.name === 'end_date') {
                    date = new Date(taskModel && taskModel.get('finish') ? taskModel.get('finish') : value.end_date - 1);
                }
                date.setHours(0, 0, 0, 0);

                this.datePicker.setValue(date);
            },
            get_value: function (id, column, node) {
                return this.datePicker.getValue();
            },
            is_changed: function (value, id, column, node) {
                let d1 = new Date(column.name === 'start_date' ? value.start_date : value.end_date - 1),
                    d2 = new Date(this.datePicker.getValue());

                d1.setHours(0, 0, 0, 0);
                d2.setHours(0, 0, 0, 0);

                return d1.getTime() !== d2.getTime() || (value.unscheduled && this.datePicker.getValue() != null);
            },
            is_valid: function (value, id, column, node) {
                return value !== null
            },
            save: function (id, column, node) {
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);

                if (column.name === 'start_date') {
                    task.start_date = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(this.datePicker.getValue()), 1, !taskModel.get('weekendWork'), true);
                    task.end_date = PJQ.helpers.dateHelpers.getNewDateAddDays(task.start_date, task.duration > 0 ? task.duration : 1, !taskModel.get('weekendWork'), true);
                } else {
                    let duration = PJQ.helpers.dateHelpers.getDateDaysDiff(this.datePicker.getValue(), task.start_date, !taskModel.get('weekendWork'), true);
                    task.end_date = PJQ.helpers.dateHelpers.getNewDateAddDays(task.start_date, duration > 0 ? duration : 1, !taskModel.get('weekendWork'), true);
                }

                if (typeof self.options.onTaskMoved === 'function') {
                    self.options.onTaskMoved(taskModel, task, column.name, true);
                }
                if (self.currentSort) {
                    self.sort();
                }
            },
            focus: function (node) {
                let input = self.getInput(node);

                if (!input) {
                    return;
                }
                if (input.focus) {
                    input.focus();
                }

                if (input.select) {
                    input.select();
                }
            }
        }

        //Duration Editor
        gantt.config.editor_types.durationEditor = {
            show: function (id, column, config, placeholder) {
                let task = self.getTask(id);
                self.showDate(task.start_date);

                placeholder.innerHTML = '<input type="number" class="form-control number-editor-input fs-13">';
            },
            set_value: function (value, id, column, node) {
                let input = self.getInput(node)
                if (input) {
                    input.value = value.duration;
                }
            },
            get_value: function (id, column, node) {
                let input = self.getInput(node)
                if (input) {
                    return input.value || 0;
                }
            },
            is_changed: function (value, id, column, node) {
                let currentValue = this.get_value(id, column, node);
                return Number(value.duration) !== Number(currentValue);
            },
            is_valid: function (value, id, column, node) {
                return !isNaN(parseInt(value)) && value > 0;
            },
            save: function (id, column, node) {
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);

                task.duration = parseInt(this.get_value(id, column, node));
                task.end_date = PJQ.helpers.dateHelpers.getNewDateAddDays(task.start_date, task.duration, !taskModel.get('weekendWork'), true);

                if (typeof self.options.onTaskMoved === 'function') {
                    self.options.onTaskMoved(taskModel, task, column.name, true);
                }
                if (self.currentSort) {
                    self.sort();
                }
            },
            focus: function (node) {
                let input = self.getInput(node);

                if (!input) {
                    return;
                }
                if (input.focus) {
                    input.focus();
                }

                if (input.select) {
                    input.select();
                }
            }
        }

        //Name Editor
        gantt.config.editor_types.nameEditor = {
            show: function (id, column, config, placeholder) {
                let task = self.getTask(id);
                self.showDate(task.start_date);
                placeholder.innerHTML = '<input type="text" class="form-control name-editor-input fs-13">';
            },
            hide: function () {
            },
            set_value: function (value, id, column, node) {
                self.getInput(node).value = value.text;
            },
            get_value: function (id, column, node) {
                return self.getInput(node).value || '';
            },
            is_changed: function (value, id, column, node) {
                let currentValue = this.get_value(id, column, node);
                return value.text !== currentValue;
            },
            is_valid: function (value, id, column, node) {
                return value != null;
            },
            save: function (id, column, node) {
                let task = self.getTask(id),
                    taskModel = self.collection.get(id);

                task.text = this.get_value(id, column, node);

                if (typeof self.options.onTaskMoved === 'function') {
                    self.options.onTaskMoved(taskModel, task, column.name);
                }
                if (self.currentSort) {
                    self.sort();
                }
            },
            focus: function (node) {
                let input = self.getInput(node);

                if (!input) {
                    return;
                }
                if (input.focus) {
                    input.focus();
                }

                if (input.select) {
                    input.select();
                }
            }
        }

        let formatter = gantt.ext.formatters.durationFormatter({
            enter: "day",
            store: "day",
            format: "auto"
        });
        let linksFormatter = gantt.ext.formatters.linkFormatter({durationFormatter: formatter});

        let dateEditor = {
                type: "dateEditor",
                map_to: "auto"
            },
            durationEditor = {
                type: "durationEditor",
                map_to: "auto"
            },
            nameEditor = {
                type: "nameEditor",
                map_to: "auto"
            },
            predecessorEditor = {type: "predecessor", map_to: "auto", formatter: linksFormatter}

        // Change task list display
        gantt.config.columns = [
            {name: "wbs", label: "#", width: 40, template: gantt.getWBSCode, resize: true},
            {name: "text", label: "Name", tree: true, width: 200, resize: true, editor: nameEditor},
            {name: "start_date", label: "Start", width: 85, align: "center", resize: true, editor: dateEditor},
            {name: "end_date", label: "Finish", width: 85, align: "center", resize: true, editor: dateEditor},
            {
                name: "duration",
                label: "Duration",
                width: 75,
                align: "center",
                resize: true,
                editor: durationEditor,
                sort: false
            },
            {
                name: "predecessors", label: "WBS", width: 80, align: "left",
                editor: predecessorEditor, resize: true, template: function (task) {
                    let links = task.$target;
                    let labels = [];
                    for (let i = 0; i < links.length; i++) {
                        let link = gantt.getLink(links[i]);
                        labels.push(linksFormatter.format(link));
                    }
                    return labels.join(", ")
                }
            },
            {name: "add"}
        ];

        // Display text on task if it fits in the task, otherwise display to the right of the task
        gantt.templates.task_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task)) return " "
            else return task.text
        }, this);

        gantt.templates.rightside_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task) || task.type === 'milestone')
                return task.text;
        }, this);

        //Change open/closed folder icons for gantt tree
        gantt.templates.grid_folder = _.bind(function (item) {
            if (item.$open) {
                return '<div class="text-align-center"><i class="fad fa-folder-open ml-1 mr-1" style="margin-top: 50%;"></i></div>'
            } else {
                return '<div class="text-align-center"><i class="fad fa-folder-closed ml-1 mr-1" style="margin-top: 50%;"></i></div>'
            }
        }, this)

        gantt.templates.grid_row_class = _.bind(function (start, end, task) {
            if (task.type !== 'project') {
                return "normal_task"
            }
            return "";
        }, this);

        // Change icons for non-parent tasks on gantt tree - Changed to no icon
        gantt.templates.grid_file = _.bind(function (item) {
            if (item.unscheduled) {
                return '<div class="text-align-center"><i class="fad fa-exclamation-circle text-danger ml-1 mr-1 p-1" title="Unscheduled Task" style="margin-top: 25%;"></i></div>'
            } else if (item.type === 'milestone') {
                return '<div class="text-align-center"><i class="fad fa-flag text-success ml-1 mr-1 p-1" title="Milestone" style="margin-top: 25%;"></i></div>'
            }
            return '<div class="text-align-center"><i class="fad fa-check ml-1 mr-1 p-1" style="margin-top: 25%;"></i></div>'
        }, this)

        // define class for summary tasks
        gantt.templates.task_class = (start, end, task) => {
            if (task.type === 'project') {
                return "summary-task-bar";
            }
        };

        // Resize Scales
        gantt.config.scale_height = 75;

        //Enable row drag and drop
        if (!this.options.enableSorting) {
            gantt.config.order_branch = true;
        }
        // gantt.config.order_branch_free = false;

        // The gantt will display 1 duration day as the next date, where we interpret it as the same date, e.g, 1 duration date to the gantt will display
        // Sept. 19, 2022 - Sept. 20, 2022. We interpret 1 duration day as Sept. 19, 2022 - Sept. 19, 2022
        gantt.templates.task_end_date = function (date, a) {
            return gantt.templates.task_date(new Date(date.valueOf() - 1));
        };

        // Expand all nested tasks initially
        gantt.config.open_tree_initially = true;

        //Set gantt to read only
        gantt.config.readonly = !this.options.canEdit || this.options.settings.get('lockSchedule');

        // addTaskLayer functions added to onGanttReady, so they are added every time the gantt is initialized
        gantt.attachEvent("onGanttReady", _.bind(function (field, direction, parent) {
            let sizeEl = document.querySelectorAll(".gantt_grid")[0],
                ganttContainer = document.querySelectorAll(".schedule-dashboard-view")[0],
                sizeElRect = sizeEl.getBoundingClientRect();

            this.gridCollapse = document.createElement("div");
            ganttContainer.append(this.gridCollapse);
            this.gridCollapse.innerHTML = '<i class="fas fa-caret-left" style="margin-top: 60%; margin-left: 35%"></i>'

            this.gridCollapse.classList.add('grid-toggle');
            this.gridCollapse.style.top = (sizeElRect.height / 2) + 'px';
            this.gridCollapse.style.left = sizeElRect.width + 'px';

            //Display Percent Complete on task bar
            gantt.addTaskLayer(function (task) {
                if (gantt.getState().drag_id == task.id && task.type !== 'milestone') {
                    let sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
                        el = document.createElement('div'),
                        progressAmount = Math.round(task.progress * 100)
                    el.className = 'progress_value';
                    el.innerHTML = progressAmount + "%";
                    el.style.left = sizes.left + (sizes.width / 3) + 'px';
                    el.style.top = sizes.top + 40 + 'px';
                    if (progressAmount === 100) {
                        el.style.backgroundColor = '#28a745'
                    } else if (progressAmount >= 60) {
                        el.style.backgroundColor = '#ffc107'
                    } else {
                        el.style.backgroundColor = '#dc3545'
                    }
                    return el;
                }
                return false;
            });

            // Summary Task left triangle
            gantt.addTaskLayer(function (task) {
                if (task.type === 'project') {
                    let sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
                        el = document.createElement('div')
                    el.className = 'summary-task-left';
                    el.style.left = sizes.left + 'px';
                    el.style.top = sizes.top + 22 + 'px';

                    return el;
                }
            });

            // Summary Task right triangle
            gantt.addTaskLayer(function (task) {
                if (task.type === 'project') {
                    let sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
                        el = document.createElement('div')
                    el.className = 'summary-task-right';
                    el.style.left = (sizes.left + sizes.width - 20) + 'px';
                    el.style.top = sizes.top + 22 + 'px';

                    return el;
                }
            });
        }, this));

        // Define date format
        let gridDateToStr = gantt.date.date_to_str("%m-%d-%Y");

        // Modify grid date format to fix display
        gantt.templates.date_grid = function (date, task, column) {
            if (task.unscheduled) {
                task.duration = 0;
                return '';
            } else if (column === "end_date" && task.type !== 'milestone') {
                return gridDateToStr(new Date(date.valueOf() - 1));
            } else {
                return gridDateToStr(date);
            }
        };

        // Enable critical path
        gantt.plugins({
            critical_path: true,
            marker: true
        });

        // Declare zoom scales
        let zoomConfig = {
            levels: [
                {
                    name: "day",
                    scale_height: 40,
                    min_column_width: 25,
                    scales: [
                        {
                            unit: "week",
                            format: function (date) {
                                let dateToStr = gantt.date.date_to_str("%d %M");
                                return dateToStr(date);
                            }
                        },
                        {
                            unit: "day",
                            step: 1,
                            format: function (date) {
                                let dateToStr = gantt.date.date_to_str("%D"),
                                    day = dateToStr(date),
                                    dayNum = date.getDay();
                                return (dayNum === 0 || dayNum === 4) ? day.substring(0, 2) : day[0];
                            },
                            css: function (date) {
                                if (date.getDay() === 0 || date.getDay() === 6) {
                                    return "weekend-highlight";
                                }
                                return "";
                            }
                        }
                    ]
                },
                {
                    name: "week",
                    scale_height: 35,
                    min_column_width: 100,
                    scales: [
                        {unit: "month", format: "%F %Y"},
                        {
                            unit: "week", step: 1, format: function (date) {
                                let dateToStr = gantt.date.date_to_str("%d"),
                                    endDate = gantt.date.add(date, 6, "day");
                                return dateToStr(date) + "-" + dateToStr(endDate);
                            }
                        }
                    ]
                },
                {
                    name: "month",
                    scale_height: 35,
                    min_column_width: 80,
                    scales: [
                        {unit: "year", format: "%Y"},
                        {unit: "month", format: "%M"}
                    ]
                },
                {
                    name: "quarter",
                    scale_height: 35,
                    min_column_width: 90,
                    scales: [
                        {unit: "year", format: "%Y"},
                        {
                            unit: "quarter", step: 1, format: function (date) {
                                return "Quarter " + (Math.floor((date.getMonth() / 3)) + 1)
                            }
                        }
                    ]
                },
                {
                    name: "year",
                    scale_height: 35,
                    min_column_width: 30,
                    scales: [
                        {unit: "year", step: 1, format: "%Y"}
                    ]
                }
            ],
            activeLevelIndex: 0
        };

        // initialize zoom
        gantt.ext.zoom.init(zoomConfig);

        // Allows sorting tasks on task bar
        gantt.config.sort = this.options.enableSorting;

        // Initialize Chart
        gantt.init(this.options.el[0]);

        // Parse tasks into gantt from existing data
        let ganttData = this.getDataObject();
        gantt.parse(ganttData);

        if (ganttData.hasTaskNearToday) {
            let pos = gantt.posFromDate(new Date());
            gantt.scrollTo(pos);
        } else if (ganttData.minStartDate != null) {
            let pos = gantt.posFromDate(ganttData.minStartDate);
            gantt.scrollTo(pos);
        }

        // Set default sort to start date
        if (this.currentSort) {
            this.sort();
        }

        this.attachEvents();
        this.renderTodayMarker();

        if (this.options.isShowCriticalPath) {
            this.toggleCriticalPath(this.options.isShowCriticalPath);
        }
    },
    renderTodayMarker: function () {
        if (this.isExporting) {
            if (this.todayMarkerId == null) {
                return;
            }

            this.gantt.deleteMarker(this.todayMarkerId);
            this.todayMarkerId = null;
        } else {
            if (this.todayMarkerId != null) {
                this.gantt.deleteMarker(this.todayMarkerId);
                this.todayMarkerId = null;
            }

            // Add today marker
            let dateToStr = this.gantt.date.date_to_str(gantt.config.task_date);
            this.todayMarkerId = this.gantt.addMarker({
                start_date: new Date(), //a Date object that sets the marker's date
                css: "today-marker", //a CSS class applied to the marker
                text: "Today",
                title: dateToStr(new Date())
            });
        }
    },
    checkTaskOverflow: function (task, dateText) {
        let task_width = this.gantt.getTaskPosition(task, task.start_date, task.end_date);

        let element = document.createElement('canvas'),
            context = element.getContext("2d"),
            task_element = document.getElementsByClassName("gantt_task_content")[0];
        if (task_element) {
            let task_font_family = getComputedStyle(task_element)['font-family'],
                task_font_size = getComputedStyle(task_element)['font-size'];
            context.font = task_font_size + ' ' + task_font_family;
        }
        let date_text_width = 0
        let task_text_width = context.measureText(task.text).width;
        if (dateText) {
            date_text_width = context.measureText(dateText).width;
        }
        if ((task_text_width + 60) > task_width.width || (date_text_width + 60) > task_width.width)
            return true;
    },
    renderForExport: function () {
        this.isExporting = true;

        this.gantt.templates.task_text = _.bind(function (start, end, task) {
            let dateString = PJQ.helpers.dateHelpers.getDateString(task.start_date, PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            if (task.type !== 'milestone') {
                dateString += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(task.end_date - 1), PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            }
            if (this.checkTaskOverflow(task, dateString)) return " "
            else return '<div style="position: absolute; top: -4px"><div style="height: 12px; line-height: 75%; margin-top: 7px">' + task.text + '</div> <div class="mb-1" style="height: 12px; line-height: 100%;">' + dateString + '</div></div>';
        }, this);

        this.gantt.templates.rightside_text = _.bind(function (start, end, task) {
            let dateString = PJQ.helpers.dateHelpers.getDateString(task.start_date, PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            if (task.type !== 'milestone') {
                dateString += ' - ' + PJQ.helpers.dateHelpers.getDateString(new Date(task.end_date - 1), PJQ.helpers.dateHelpers.dateFormats.DATE, false);
            }
            if (this.checkTaskOverflow(task, dateString) || task.type === 'milestone')
                return '<div><div style="height: 10px; line-height: 75%; margin-top: 7px">' + task.text + '</div> <div class="mb-1" style="height: 12px; line-height: 100%;">' + dateString + '</div></div>';
        }, this);

        this.renderTodayMarker();

        this.gantt.render();
    },
    renderForViewing: function () {
        this.isExporting = false;

        this.gantt.templates.task_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task)) return " "
            else return task.text
        }, this);

        this.gantt.templates.rightside_text = _.bind(function (start, end, task) {
            if (this.checkTaskOverflow(task) || task.type === 'milestone')
                return task.text;
        }, this);

        this.renderTodayMarker();

        this.gantt.render();
    },
    toggleGrid: function () {
        this.gantt.config.show_grid = !this.gantt.config.show_grid;
        this.gantt.render();

        if (this.gantt.config.show_grid) {
            let sizeEl = document.querySelectorAll(".gantt_grid")[0],
                sizeElRect = sizeEl.getBoundingClientRect();
            this.gridCollapse.style.top = (sizeElRect.height / 2) + 'px';
            this.gridCollapse.style.left = sizeElRect.width + 'px';
            this.gridCollapse.innerHTML = '<i class="fas fa-caret-left" style="margin-top: 60%; margin-left: 35%"></i>'
        } else {
            let sizeEl = document.querySelectorAll(".gantt_container")[0],
                sizeElRect = sizeEl.getBoundingClientRect();
            this.gridCollapse.style.top = (sizeElRect.height / 2) + 'px';
            this.gridCollapse.style.left = 0 + 'px';
            this.gridCollapse.innerHTML = '<i class="fas fa-caret-right" style="margin-top: 60%; margin-left: 35%"></i>'
        }
    },
    attachEvents: function () {
        // Reopen the datePicker if scales are adjusted when editing the start_date
        this.gantt.attachEvent("onScaleAdjusted", _.bind(function () {
            let editorState = this.gantt.ext.inlineEditors.getState();
            if (editorState.columnName === 'end_date') {
                editorState.editor.datePicker.show();
            }
        }, this));

        this.gantt.attachEvent("onBeforeGanttRender", () => {
            let range = this.gantt.getSubtaskDates();
            if (range.start_date == null || range.end_date == null) {
                return;
            }

            if (this.isExporting) {
                this.gantt.config.start_date = this.gantt.calculateEndDate(range.start_date, -3, 'day');
                this.gantt.config.end_date = this.gantt.calculateEndDate(range.end_date, 5, 'day');
            } else {
                this.gantt.config.start_date = this.gantt.calculateEndDate(range.start_date, -30, 'day');
                this.gantt.config.end_date = this.gantt.calculateEndDate(range.end_date, 30, 'day');
            }
        });

        // Override the default dhtmlx modal for updating task
        this.gantt.attachEvent("onBeforeLightBox", _.bind(function (id) {
            id = parseInt(id);
            if (id != null && typeof this.options.onTaskEdit === 'function') {
                let taskModel = this.collection.get(id),
                    ganttTask = this.getTask(id);
                if (taskModel != null) {
                    // gantt.ext.quickInfo.hide();
                    this.options.onTaskEdit(taskModel);
                } else {
                    if (typeof this.options.onTaskAdd === 'function') {
                        let callback = _.bind(function (taskModel) {
                            this.gantt.ext.inlineEditors.startEdit(taskModel.get('taskId'), 'text');
                        }, this);
                        this.options.onTaskAdd(ganttTask, callback);
                    }
                }
            } else
                return true;
        }, this));

        // Change position of gridCollapse button when grid is resized
        this.gantt.attachEvent("onGridResizeEnd", _.bind(function (old_width, new_width) {
            this.gridCollapse.style.left = new_width + 'px';
            return true;
        }, this));

        // Disable editing on certain inline editors in certain cases
        this.gantt.ext.inlineEditors.attachEvent("onBeforeEditStart", _.bind(function (state) {
            let task = this.getTask(state.id);
            if (task && state.columnName === 'duration' && (task.unscheduled || task.type === 'project')) {
                return false;
            } else if (task && (state.columnName === 'start_date' || state.columnName === 'end_date') && task.type === 'project') {
                return false;
            } else if (task && state.columnName === 'start_date' && _.size(task.$target) > 0) {
                if ((PJQ.app.session.project && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)) ||
                    (PJQ.app.session.project == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED))) {
                    return false;
                }
            }
            return true;
        }, this));

        // Store the sort if it is changed
        this.gantt.attachEvent("onAfterSort", _.bind(function (field, direction, parent) {
            this.gantt.config.order_branch = false;
            if (field === 'wbs') {
                field = 'sortOrder';
                this.gantt.config.order_branch = true;
                this.gantt.clearAll();
                this.gantt.parse(this.getDataObject());
            }
            this.currentSort = {
                field: field,
                asc: direction
            };
            if (typeof this.options.onSort === 'function') {
                this.options.onSort(this.currentSort);
            }
            this.gantt.render();
        }, this));

        // Override dhtmlx gantt error with our own
        this.gantt.attachEvent("onError", _.bind(function (errorMessage) {
            PJQ.notifications.notify.errorNotify({
                message: errorMessage
            });
            return false;
        }, this));

        // Override dhtmlx gantt error with our own
        this.gantt.attachEvent("onTaskCreated", _.bind(function (task) {
            let callback = _.bind(function (taskModel) {
                this.gantt.showTask(taskModel.get('taskId'));
                this.gantt.ext.inlineEditors.startEdit(taskModel.get('taskId'), 'text');
            }, this);
            this.options.onTaskAdd(task, callback);
        }, this));

        // Handle task deletion through gantt
        this.gantt.attachEvent("onAfterTaskDelete", _.bind(function (id, item) {
            let taskModel = this.collection.get(id);
            if (typeof this.options.onTaskDelete === 'function') {
                this.options.onTaskDelete(taskModel);
            }
        }, this));

        // Handle on task dragging
        this.gantt.attachEvent("onTaskDrag", _.bind(function (id, mode, task, original, e) {
            let taskModel = this.collection.get(id);
            if (!taskModel) {
                return;
            }
            // Prevent dragging before the minimum start date
            if (task.start_date < taskModel.getMinStart()) {
                task.start_date = original.start_date;
                task.end_date = original.end_date;
            }

            //Prevent dragging on tasks with a predecessor && ASAP Constraints enabled
            if (mode === 'move' && _.size(task.$target) > 0 &&
                ((PJQ.app.session.project && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)) ||
                    (PJQ.app.session.project == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ASAP_SCHEDULE_CONTRAINT_ENABLED)))) {
                task.start_date = original.start_date;
                task.end_date = original.end_date;
            }
        }, this));

        this.gantt.attachEvent("onRowDragEnd", _.bind(function (id, target) {
            let task = this.getTask(id);
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'schedule'
                    },
                    {
                        endpoint: 'tasks',
                        value: task.id
                    },
                    {
                        endpoint: 'sort',
                        value: task.$local_index + 1
                    }
                ]),
                data: { cloudFlareFix: true }
            }).put().done(_.bind(function () {
                let newSort = task.$local_index + 1,
                    oldSort = task.sortOrder;
                if (this.collection) {
                    let taskModel = this.collection.get(id),
                        summaryTaskId = taskModel.get('summaryTaskId'),
                        sorted = _.sortBy(_.filter(this.collection.models, (mod) => {
                            return (!(summaryTaskId > 0) && mod.get('summaryTaskId') == null) || mod.get('summaryTaskId') === summaryTaskId;
                        }), (mod) => {
                            let mSort = mod.get('sortOrder');
                            if (mod.id.toString() === id) {
                                return newSort;
                            } else if (oldSort > newSort && mSort >= newSort) {
                                return mSort + 1;
                            } else if (oldSort < newSort && mSort === newSort) {
                                return mSort - 1
                            } else if (oldSort < newSort && mSort > newSort) {
                                return mSort + 1;
                            }
                            return mSort;
                        });
                    _.each(sorted, (mod, i) => {
                        mod.set('sortOrder', i + 1);
                    });
                }
                task.sortOrder = newSort;
            }, this));
        }, this));

        // Disable dragging between summary tasks
        this.gantt.attachEvent("onBeforeRowDragEnd", _.bind(function (id, parent) {
            let task = this.getTask(id);
            return task.parent === parent;
        }, this));

        // Handle after task dragging
        this.gantt.attachEvent("onAfterTaskDrag", _.bind(function (id, mode, e) {
            let task = this.getTask(id),
                taskModel = this.collection.get(id);
            if (typeof this.options.onTaskMoved === 'function') {
                this.options.onTaskMoved(taskModel, task);
            }
            if (this.currentSort) {
                this.sort();
            }
        }, this));

        // Handle Dependency adding
        this.gantt.attachEvent("onAfterLinkAdd", _.bind(function (id, item) {
            let taskModel = this.collection.get(parseInt(item.target));
            if (typeof this.options.onDependencyAdd === 'function') {
                this.options.onDependencyAdd(taskModel, item);
            }
        }, this));

        // Handle Dependency deletion
        this.gantt.attachEvent("onAfterLinkDelete", _.bind(function (id, item) {
            let taskModel = this.collection.get(parseInt(item.target));
            if (typeof this.options.onDependencyAdd === 'function') {
                this.options.onDependencyDelete(taskModel, item);
            }
        }, this));
    },
    sort: function (override) {
        this.gantt.sort(override != null ? override : this.currentSort.field, this.currentSort.asc);
    },
    getTask: function (id) {
        return this.gantt.getTask(id);
    },
    getZoom: function () {
        return this.gantt.ext.zoom.getCurrentLevel();
    },
    zoomIn: function () {
        this.gantt.ext.zoom.zoomIn();
    },
    zoomOut: function () {
        this.gantt.ext.zoom.zoomOut();
    },
    getInput: function (node) {
        return node.querySelector("input");
    },
    showTask: function (id) {
        this.gantt.showTask(id);
    },
    showDate: function (date) {
        this.gantt.showDate(date);
    },
    updateLink: function (id) {
        this.gantt.updateLink(id);
    },
    renderContextMenu: function () {
        this.options.contextMenuOptions = {
            actions: [
                {
                    name: 'View Details',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.editTask(task);
                    }, this)
                },
                {
                    name: 'Add Sub-Task',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.addSubTaskClicked(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        return !this.options.settings.get('lockSchedule');
                    }, this)
                },
                {
                    name: 'Add to Summary Task',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.addToSummaryTaskClicked(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        return !this.options.settings.get('lockSchedule');
                    }, this)
                },
                {
                    name: 'Remove from Summary Task',
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.removeSummaryTask(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        return task.get('summaryTaskId') > 0 && !this.options.settings.get('lockSchedule');
                    }, this)
                },
                {
                    name: 'Delete',
                    isDanger: true,
                    onClick: _.bind(function (row) {
                        let id = row.data('task-id'),
                            task = this.collection.get(id);
                        this.deleteTask(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        return !this.options.settings.get('lockSchedule');
                    }, this)
                }
            ]
        }
        this.contextMenu = new PJQ.menus.ContextMenu(_.defaults(this.options.contextMenuOptions, {
            el: this.$('.gantt_container'),
            selector: '.gantt_bar_task, .gantt_row_task, .gantt_bar_project, .gantt_row_project, .gantt_row_milestone, .gantt_bar_milestone',
            fetchElementData: _.bind(function (element) {
                return element
            }, this),
            onOpen: _.bind(function (row) {
            }, this),
            onClose: _.bind(function () {
                this.$('.context-row').removeClass('context-row');
            }, this)
        }));
    },
    editTask: function (task) {
        if (typeof this.options.onTaskEdit === 'function') {
            this.options.onTaskEdit(task);
        }
    },
    removeSummaryTask: function (task) {
        if (typeof this.options.onTaskUpdateSummary === 'function') {
            this.options.onTaskUpdateSummary(task, 0);
        }
    },
    addToSummaryTaskClicked: function (task) {
        new PJQ.views.charts.SummaryTaskModal({
            tasks: this.collection,
            task: task,
            project: this.options.project,
            schedule: this.options.schedule,
            onSave: _.bind(function (task, summaryTaskId, isNewTask = false) {
                if (typeof this.options.onTaskUpdateSummary === 'function') {
                    this.options.onTaskUpdateSummary(task, summaryTaskId, isNewTask);
                }
            }, this)
        });
    },
    addSubTaskClicked: function (task) {
        if (typeof this.options.onAddSubTask === 'function') {
            this.options.onAddSubTask(task);
        }
    },
    deleteTaskClicked: function (e) {
        let taskId = $(e.currentTarget).closest('.task-popup').data('taskId'),
            task = this.collection.get(taskId);
        this.deleteTask(task);
    },
    deleteTask: function (task) {
        if (typeof this.options.onTaskDelete === 'function') {
            this.options.onTaskDelete(task);
        }
    },
    addTask: function (taskModel, parentId) {
        let taskObj = {
            text: taskModel.get('name'),
            start_date: taskModel.get('start'),
            duration: taskModel.get('duration'),
            id: taskModel.get('taskId'),
            type: taskModel.get('isMilestone') ? 'milestone' : taskModel.get('isSummaryTask') ? 'project' : 'task',
            progress: (taskModel.get('percentComplete') / 100),
            parent: taskModel.get('summaryTaskId') ? taskModel.get('summaryTaskId') : taskModel.get('parentTaskId'),
            calendar_id: taskModel.get('weekendWork') ? "weekend_work" : null
        };

        this.gantt.addTask(taskObj);

        // Handle dependencies for new task
        _.each(taskModel.dependencies.models, function (dependency) {
            if (dependency.get('taskId') === taskModel.get('taskId')) {
                let linkObj = {
                    id: dependency.get('dependencyId'),
                    target: dependency.get('taskId'),
                    source: dependency.get('dependTaskId'),
                    type: dependency.get('type') === 'FS' ? "0" : "1",
                    lag: dependency.get('offset')
                }

                this.addLink(linkObj);
            }
        }, this);
    },
    addLink: function (linkObj) {
        this.gantt.addLink(linkObj);
    },
    toggleCriticalPath: function (bool) {
        this.gantt.config.highlight_critical_path = bool;
        this.gantt.render();
    },
    refreshTasks: function () {
        let scroll = this.gantt.getScrollState();
        this.gantt.clearAll();
        this.gantt.parse(this.getDataObject());
        if (this.currentSort) {
            this.sort();
        }
        this.gantt.scrollTo(scroll.x, scroll.y);
        this.renderTodayMarker();
    },
    updateTask: function (taskModel) {
        let task = this.gantt.getTask(taskModel.get('taskId')),
            // If start date is null we want to use the latest task start date. If there are no other tasks we just want to use today's date.
            hasTaskWithStartDate = _.find(this.collection.models, function (model) {
                return model.get('start') != null;
            }),
            maxStartDate = hasTaskWithStartDate ? new Date(Math.max(...this.collection.models.map(model => new Date(model.get('start'))))) : new Date();
        // Since we subtracted a day for the API, we have to add it back for the gantt to be correct.
        let endDate = new Date(taskModel.get('finish'));
        endDate = endDate.addDays(1);
        endDate.setHours(0, 0, 0, 0);
        task.start_date = taskModel.get('start') != null ? taskModel.get('start') : maxStartDate;
        task.end_date = endDate;
        task.duration = taskModel.get('duration');
        task.unscheduled = taskModel.get('start') == null || taskModel.get('finish') == null;

        this.gantt.updateTask(task.id);
    },
    exportToPDF: function (callback) {
        if (!this.gantt) {
            return;
        }
        this.getCompanyLogoUrl(_.bind(function (logoURL) {
            this.renderForExport();
            setTimeout(() => {
                this.gantt.exportToPDF({
                    name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.pdf",
                    header: "<style>.weekend-highlight{background-color: #eee !important;}.chart-outer{position:relative}.gantt-container{height:100%!important;flex:1;display:flex;position:relative}.task-list-header{height:39px;width:600px;background-color:#fff;z-index:9999999}.task-list-task{height:50px;width:600px;text-align:left;align-content:start;font-size:16px;border-bottom:1px solid #eaeaea;transition:border-right-width 0.2s linear;&:hover{color:#156cb1!important;background:#f8f9fa!important;border-right-width:10px!important}}.task-list-div{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff;position:absolute;left:0;top:0}.task-list-fill{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff}.task-list-input{padding:.39rem .3rem!important;margin-top:0.6rem!important}.gantt{display:flex;.lower-text{font-size:15px!important;font-weight:300!important}.upper-text{font-size:16px!important;font-weight:500!important}.bar-label{font-size:14px!important;font-weight:500!important;&.big{font-weight:700!important;color:#343a40!important}}.today-highlight{fill:rgba(0,109,255,.35)!important;opacity:inherit!important}.weekend-highlight{fill:rgba(94,53,177,.1)!important;opacity:inherit!important}.row-line{stroke:#b6b6b6!important;stroke-width:.4!important}.tick{stroke:transparent!important;stroke-width:.4!important}}.gantt_qi_big_icon.icon_delete{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#dc3545;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #dc3545;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:10px;&:hover{color:#fff;background-color:#c82333;border-color:#bd2130;text-decoration:none}}.gantt_qi_big_icon.icon_edit{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#17a2b8;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #17a2b8;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:12px;min-width:50px;&:hover{color:#fff;background-color:#138496;border-color:#117a8b;text-decoration:none}}.icon_edit{background-image:none!important;width:0!important}.icon_delete{background-image:none!important;width:0!important}.progress_value{position:absolute;border-radius:5px;margin-top:-7px;height:20px;width:40px;color:#fff;z-index:99999;text-align:center}.summary-task-bar{background-color:#000!important;border:1px solid #000!important}.summary-task-bar .gantt_task_progress_wrapper .gantt_task_progress{border:1px solid #4f4f4f!important;background:#5a5a5a!important;box-shadow:none!important}.summary-task-left{position:absolute;border-top:20px solid #000;border-right:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.summary-task-right{position:absolute;border-top:20px solid #000;border-left:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.milestone-icon{position:absolute;z-index:99999;padding:3px;margin-left:-10px;margin-top:8px;pointer-events:none}.gantt_task_line.gantt_milestone{border-radius:50%}.gantt_critical_task{background-color:#e63030!important;border-color:#9d3a3a!important}.gantt_container{font-family:Roboto,sans-serif;font-weight:400}.gantt_row.odd,.gantt_task_row.odd,.gantt_row,.gantt_task_row{background:white!important;border-bottom:1px solid #e8e8e8!important}.gantt_grid_data{background:white!important}.gantt_task .gantt_task_scale .gantt_scale_cell{background-color:#FFFFFF!important}.gantt_grid_scale .gantt_grid_head_cell{border-left:none!important;border-right:none!important;background-color:#FFFFFF!important;color:#212529;font-size:12px!important}.gantt_task_scale{border-bottom:none!important}.gantt_scale_line{border-bottom:none;border-top:none!important}.gantt_scale_cell{font-size:12px!important;border-bottom:1px solid #b3b3b3}.today-marker{background-color:rgb(0 0 0 / 60%)}.normal_task .gantt_add{display:none} </style>" + (PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) != null ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) : "<div style='display: flex; font-size: 24px; background: #022c52; color: #FFFFFF; padding: 20px; font-family: sans-serif;'> <img src='" + logoURL + "' alt='Company Logo' style='margin-bottom: auto; max-width: 200px; margin-right:20px;'/> <div style='align-self: flex-end; margin-left:20px;'> <div style='font-weight: bold;'>" + PJQ.app.session.project.get('projectName') + "</div><div>" + PJQ.app.session.project.get('address1') + "</div><div>" + PJQ.app.session.project.get('city') + ", " + PJQ.app.session.project.get('state') + " " + PJQ.app.session.project.get('zip') + " </div></div></div>"),
                    raw: true,
                    server: PJQ.helpers.urlHelpers.buildApiUrl('/schedule/export', {
                        service: PJQ.constants.services.APIv2
                    })
                });

                this.renderForViewing();
                if (typeof callback === 'function') {
                    callback();
                }
            }, 1);
        }, this));
    },
    exportToExcel: function (callback) {
        if (!this.gantt) {
            return;
        }
        this.getCompanyLogoUrl(_.bind(function (logoURL) {
            this.gantt.exportToExcel({
                name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.xlsx",
                visual: "base-colors",
                cellColors: true,
                date_format: "mmmm d, yyyy",
                project: PJQ.app.session.project,
                logoURL: logoURL,
                server: PJQ.helpers.urlHelpers.buildApiUrl('/schedule/export', {
                    service: PJQ.constants.services.APIv2
                })
            });
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    },
    exportToPNG: function (callback) {
        if (!this.gantt) {
            return;
        }
        this.getCompanyLogoUrl(_.bind(function (logoURL) {
            this.renderForExport();
            this.gantt.exportToPNG({
                name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.png",
                header: "<style>.gantt_container{margin: 20px;}.chart-outer{position:relative}.gantt-container{height:100%!important;flex:1;display:flex;position:relative}.task-list-header{height:39px;width:600px;background-color:#fff;z-index:9999999}.task-list-task{height:50px;width:600px;text-align:left;align-content:start;font-size:16px;border-bottom:1px solid #eaeaea;transition:border-right-width 0.2s linear;&:hover{color:#156cb1!important;background:#f8f9fa!important;border-right-width:10px!important}}.task-list-div{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff;position:absolute;left:0;top:0}.task-list-fill{height:100%!important;flex:0 0 600px;width:600px!important;background-color:#fff}.task-list-input{padding:.39rem .3rem!important;margin-top:0.6rem!important}.gantt{display:flex;.lower-text{font-size:15px!important;font-weight:300!important}.upper-text{font-size:16px!important;font-weight:500!important}.bar-label{font-size:14px!important;font-weight:500!important;&.big{font-weight:700!important;color:#343a40!important}}.today-highlight{fill:rgba(0,109,255,.35)!important;opacity:inherit!important}.weekend-highlight{fill:rgba(94,53,177,.1)!important;opacity:inherit!important}.row-line{stroke:#b6b6b6!important;stroke-width:.4!important}.tick{stroke:transparent!important;stroke-width:.4!important}}.gantt_qi_big_icon.icon_delete{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#dc3545;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #dc3545;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:10px;&:hover{color:#fff;background-color:#c82333;border-color:#bd2130;text-decoration:none}}.gantt_qi_big_icon.icon_edit{font-family:Roboto,sans-serif;font-weight:400;color:#fff;background-color:#17a2b8;display:inline-block;text-align:center;vertical-align:middle;user-select:none;border:1px solid #17a2b8;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding-left:12px;min-width:50px;&:hover{color:#fff;background-color:#138496;border-color:#117a8b;text-decoration:none}}.icon_edit{background-image:none!important;width:0!important}.icon_delete{background-image:none!important;width:0!important}.progress_value{position:absolute;border-radius:5px;margin-top:-7px;height:20px;width:40px;color:#fff;z-index:99999;text-align:center}.summary-task-bar{background-color:#000!important;border:1px solid #000!important}.summary-task-bar .gantt_task_progress_wrapper .gantt_task_progress{border:1px solid #4f4f4f!important;background:#5a5a5a!important;box-shadow:none!important}.summary-task-left{position:absolute;border-top:20px solid #000;border-right:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.summary-task-right{position:absolute;border-top:20px solid #000;border-left:20px solid transparent;z-index:0;margin-top:-7px;color:#fff;text-align:center}.milestone-icon{position:absolute;z-index:99999;padding:3px;margin-left:-10px;margin-top:8px;pointer-events:none}.gantt_task_line.gantt_milestone{border-radius:50%}.gantt_critical_task{background-color:#e63030!important;border-color:#9d3a3a!important}.gantt_container{font-family:Roboto,sans-serif;font-weight:400}.gantt_row.odd,.gantt_task_row.odd,.gantt_row,.gantt_task_row{background:white!important;border-bottom:1px solid #e8e8e8!important}.gantt_grid_data{background:white!important}.gantt_task .gantt_task_scale .gantt_scale_cell{background-color:#FFFFFF!important}.gantt_grid_scale .gantt_grid_head_cell{border-left:none!important;border-right:none!important;background-color:#FFFFFF!important;color:#212529;font-size:12px!important}.gantt_task_scale{border-bottom:none!important}.gantt_scale_line{border-bottom:none;border-top:none!important}.gantt_scale_cell{font-size:12px!important;border-bottom:1px solid #b3b3b3}.today-marker{background-color:rgb(0 0 0 / 60%)}.normal_task .gantt_add{display:none}</style>" + (PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) != null ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_GANTT_HEADER_CUSTOM_MARKUP) : "<div style='display: flex; font-size: 24px; background: #022c52; color: #FFFFFF; padding: 20px; font-family: sans-serif;'> <img src='" + logoURL + "' alt='Company Logo' style='margin-bottom: auto; margin-right:20px; max-width: 200px;'/> <div style='align-self: flex-end; margin-left:20px;'> <div style='font-weight: bold;'>" + PJQ.app.session.project.get('projectName') + "</div><div>" + PJQ.app.session.project.get('address1') + "</div><div>" + PJQ.app.session.project.get('city') + ", " + PJQ.app.session.project.get('state') + " " + PJQ.app.session.project.get('zip') + " </div></div></div>"),
                skin: 'broadway',
                raw: true,
                server: PJQ.helpers.urlHelpers.buildApiUrl('/schedule/export', {
                    service: PJQ.constants.services.APIv2
                })
            });
            this.renderForViewing();
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    },
    getCompanyLogoUrl: function (callback) {
        if (this.logoURL != null) {
            callback(this.logoURL);
            return;
        }

        if (PJQ.app.session.project.get('masterUserId') > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users',
                        value: PJQ.app.session.project.get('masterUserId')
                    },
                    {
                        endpoint: 'logo'
                    }
                ])
            }).get().done(_.bind(function (response) {
                this.logoURL = response.url;
                callback(response.url);
            }, this));
        } else {
            callback(null);
        }
    },
    exportToPrimavera: function (callback) {
        this.gantt.exportToPrimaveraP6({
            name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.xer",
        });
        if (typeof callback === 'function') {
            callback();
        }
    },
    exportToMSProject: function (callback) {
        this.gantt.exportToMSProject({
            name: (PJQ.app.session.project ? PJQ.app.session.project.get('projectName') : 'Project') + "_Gantt.mpp",
        });
        if (typeof callback === 'function') {
            callback();
        }
    }
});

PJQ.views.charts.SummaryTaskModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'summary-task-modal'),
        width: '30%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-new-summary-task': 'newSummaryTaskClicked'
    },
    beforeRender: function () {
        this.existingTasks = _.filter(this.options.tasks.models, function (task) {
            let taskModel = task.get('model') ? task.get('model') : task;
            return taskModel.get('isSummaryTask')
        }, this);

        this.targetTask = this.options.task;
        this.renderData = {
            tasks: this.options.tasks.models,
            targetTask: this.targetTask
        };
    },
    afterRender: function () {
        let invalidTasks = this.getAllDescendantTaskIds();

        this.existingTaskPicker = new PJQ.inputs.Selectpicker({
            el: $('.select-existing-summary-task'),
            isLiveSearch: true,
            noneSelectedText: 'Select Existing Task',
            choices: _.map(_.filter(this.options.tasks.models, function (task) {
                return !_.contains(invalidTasks, task.get('taskId')) && task.get('taskId') !== this.targetTask.get('taskId') && task.get('taskId') !== this.targetTask.get('summaryTaskId');
            }, this), function (task) {
                return {
                    id: task.get('taskId'),
                    name: task.get('name')
                }
            }),
            onChange: _.bind(function (value) {
                let existingSummary = _.find(this.existingTasks, function (model) {
                    return model.id === parseInt(value);
                })
                if (this.warningAlert) {
                    this.warningAlert.destroy();
                }

                if (existingSummary == null) {
                    this.warningAlert = new PJQ.Alert(this.$('.summary-warning'), {
                        type: 'danger',
                        text: 'Selected task is not currently a summary task. Saving will cause selected task to convert into a summary task.'
                    });
                }
                this.summaryTaskId = value;
                this.$('.btn-save').prop('disabled', false);
            }, this)
        });
    },
    getAllDescendantTaskIds: function () {
        let descendants = [],
            findDescendants = _.bind(function (currentTaskId) {
                _.each(this.options.tasks.models, function (task) {
                    task = task.model ? task.model : task;
                    if (task.get('summaryTaskId') === currentTaskId) {
                        descendants.push(task.get('taskId'));
                        findDescendants(task.get('taskId'));
                    }
                });
            }, this);

        findDescendants(this.targetTask.get('taskId'));
        return descendants;
    },
    newSummaryTaskClicked: function () {
        let newTask = new PJQ.models.schedule.Task({
            projectId: this.targetTask ? this.targetTask.get('projectId') : null,
            templateId: this.targetTask ? this.targetTask.get('templateId') : null
        });
        this.newSummaryTask(newTask)
    },
    newSummaryTask: function (task) {
        new PJQ.views.schedule.EditTaskModal({
            project: this.options.project,
            schedule: this.options.schedule,
            isSummaryTask: true,
            model: task,
            onSave: _.bind(function () {
                task.save(null, {
                    success: _.bind(function (model) {
                        this.summaryTaskId = model.get('taskId');
                        this.options.onSave(model, null, true);
                        this.save()
                    }, this)
                })
            }, this),
            onClose: _.bind(function () {
                this.removeModal();
            }, this)
        });
    },
    save: function () {
        if (this.summaryTaskId != null) {
            this.options.onSave(this.targetTask, this.summaryTaskId)
            this.removeModal();
        }
    }
});

PJQ.views.charts.AssigneeListModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'assignee-list-modal'),
        subTemplates: {
            assignees: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'assignee-list'),
        },
        width: '30%',
        maxWidth: 700
    },
    events: {
        'click .btn-edit-assignee': 'editAssignee'
    },
    afterRender: function () {
        this.renderAssignees()
    },
    renderAssignees: function () {
        this.renderSubTemplate(false, this.options.subTemplates.assignees, this.$('.assignee-outer'), {
            assignees: this.options.assignees.models
        });
    },
    editAssignee: function (e) {
        let target = $(e.currentTarget).closest('.assignee-card'),
            cid = target.data('cid'),
            assignee = this.options.assignees.get(cid),
            model = new PJQ.models.contacts.Contact(assignee);

        new PJQ.views.contacts.BaseEditContactModal({
            model: model
        })
    }
});

PJQ.models.charts = {};
PJQ.models.charts.GanttTask = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (model.model != null) {
            this.model = model.model;
        }
        return model;
    }
});

PJQ.collections.charts = {};
PJQ.collections.charts.GanttTasks = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.charts.GanttTask
});
